// Constantes de la aplicación
export const AUTH_CONSTANTS = {
  // SGhogar_2024 encoded in base64
  ENCODED_PASSWORD: 'U0dob2dhcl8yMDI0',
  STORAGE_KEY: 'password_validated'
} as const;